import React from 'react';
import { find as _find } from 'lodash';

import {
  // Modal,
  Button,
  FormControl,
  FormGroup,
  ControlLabel,
  Col,
  Row,
  Well
} from 'react-bootstrap';

// import { FileDropAreaCt } from '../../../commonComponents/FileDropAreaCt';
// import {onFileDrop, onFileDelete} from '../../../commonComponents/onFileModify';
import Tooltip from '../../../commonComponents/Tooltip';
import DeleteBtnWithConfirm from '../../../commonComponents/DeleteBtnWithConfirm';
import DropDownMenu from '../../../commonComponents/DropDownMenu';
import RequiredMark from '../../../commonComponents/RequiredMark';

import custJqAjax from '../../../commonJS/custJqAjax';
import autoFill from '../../../commonJS/autoFill';
import parentStateHandler from '../../../commonJS/parentStateHandler';


export default class SpecDetailCt extends React.Component {
  constructor(props) {
    super(props);
    this.handlers = {
      textAreaOnChange: e => {
        const jsInp = e.currentTarget,
          id = jsInp.id,
          value = jsInp.value;

        this.setState({
          [id]: value
        });
      },
      onChange: (selection, id, cb) => {
        const value = selection.value;

        this.setState({
          [id]: value
        });

      },
      onInputFocus: e => {
        autoFill(e, this);
      },
      onEditClick: () => { this.setState({ onEdit: true, onCopy: false, editMode: "Edit" }) },
      onSortUpdate: (newSort, cb) => {
        let fd = new FormData(), sortArr = [], oldSort = this.props.activeStepSort * 1;

        fd.append('model_id', this.props.productId);
        fd.append('item_id', this.props.activeSolutionId);

        const arrObj = this.props.arrStepsObj;

        // 產生預設排序
        for (let i = 0; i < this.props.stepNum; i++) {
          // sortArr[i] = i + 1;
          sortArr[i] = arrObj[i].spec_id;
        }

        sortArr.splice(oldSort - 1, 1); // 移除舊位置

        if (newSort) {
          newSort *= 1; // 確保為數字
          sortArr.splice(newSort - 1, 0, arrObj[oldSort - 1].spec_id); // 移至新位置
        }

        fd.append('spec_id_list', sortArr);

        custJqAjax({
          type: 'POST',
          url: '/api/W_SaleSky_Product_Group_Item_Spec_Unit_Lang_Sort_Update.php',
          data: fd,
          processData: false,
          contentType: false,
          success: res => {
            if (cb) cb();
          }
        });
      },
      onSaveClick: isUpdate => {
        // if(this.uploadedFiles.length || this.state.deletedDownloadedFiles.length) {
        //   this.setState({fileWorkInProgress: true});
        // }

        let formData = new FormData(),
          sortState = this.state.sort,
          sortTemp = 0;

        const spec_name_list = `${this.state.descriptions_tw}|${this.state.descriptions_en}|${this.state.descriptions_cn}|${this.state.descriptions_ja}`,
          unit_name_list = `${this.state.unit_name_tw}|${this.state.unit_name_en}|${this.state.unit_name_cn}|${this.state.unit_name_ja}`,
          unit_value_list = `${this.state.unit_value_tw}|${this.state.unit_value_en}|${this.state.unit_value_cn}|${this.state.unit_value_ja}`;

        formData.append('model_id', this.props.productId);
        formData.append('item_id', this.props.activeSolutionId);
        formData.append('spec_name_list', spec_name_list);
        formData.append('unit_name_list', unit_name_list);
        formData.append('unit_value_list', unit_value_list);

        if (!isUpdate) {
          sortState = this.props.stepNum + 1;

          if (sortState !== this.state.sort) sortTemp = this.state.sort;

        } else formData.append('spec_id', this.state.spec_id);

        formData.append('sort', sortState);

        // api改好前暫時使用 => 最後變成沒改api…
        // api是一律以上傳內容覆蓋舊資料方式處理，上傳內容若為空白，則會刪除舊資料
        // if(this.uploadedFiles[0]) {

        // formData.append('files', this.uploadedFiles[0]);
        // }else if(this.state.deletedDownloadedFiles[0]) {
        // formData.append('files', '');
        // }

        // sort有變動之處理，若有變動，先執行sort update再執行step update
        // 預設p1為既時完成promise，sort有變時再替換為一般promise
        let p1 = new Promise((resolve, reject) => { resolve(); });

        if (isUpdate && (this.props.activeStepSort.toString() !== this.state.sort.toString())) {
          p1 = new Promise((resolve, reject) => { this.handlers.onSortUpdate(this.state.sort, resolve); });
        }

        p1.then(value => {
          custJqAjax({
            type: 'POST',
            url: `/api/W_SaleSky_ProductGroupItemSpecUnit_${isUpdate ? 'Update' : 'Post'}.php`,
            data: formData,
            processData: false,
            contentType: false,
            success: res => {
              // 順序很重要
              this.props.parentStateHandler({ states: 'activeStepSort', newValues: this.state.sort });

              const p = new Promise((resolve, reject) => {
                this.props.refreshStepData(this.props.activeSolutionId, resolve);
              });

              p.then(result => {
                this.props.parentStateHandler({ states: 'stepModMode', newValues: 'edit' });

                // 如果為新增且同時改變預設排序時，以預設sort新增後
                // 再用指定sort執行一次update
                if (sortTemp !== 0) {
                  this.props.parentStateHandler({ states: 'activeStepSort', newValues: this.props.stepNum });

                  this.setState({ sort: sortTemp }, () => {
                    this.handlers.onSaveClick(1);
                  });
                }

              }).catch(error => { });

              this.setState({
                editMode: 'View',
                onEdit: false
                // fileWorkInProgress: false
              });

            }
          });

        }).catch(error => { ; });
      },
      onDeleteClick: () => {

        let formData = new FormData();

        formData.append('model_id', this.props.productId);
        formData.append('item_id', this.props.activeSolutionId);
        formData.append('spec_id', this.state.spec_id);

        custJqAjax({
          type: 'POST',
          url: `/api/W_SaleSky_ProductGroupItemSpecUnit_Delete.php`,
          data: formData,
          processData: false,
          contentType: false,
          success: res => {
            let states = ['activeStepSort', 'stepModMode'],
              newValues = [0, ''];
            // 先重新排序，再更新step data
            const p = new Promise((resolve, reject) => {
              this.handlers.onSortUpdate('', resolve);
            });

            p.then(value => {
              this.props.refreshStepData(this.props.activeSolutionId);
              this.props.parentStateHandler({ states, newValues });
            }).catch(error => { ; });

            this.setState({ editMode: 'View', onEdit: false });
          }
        });
      }
    }

    this.parentStateHandler = ({ states, newValues }) => {
      parentStateHandler({ states, newValues, parentThis: this });
    };

    this.ajaxsWip = [];

    // file crud相關 ===========
    // for file upload，不需渲染的資料不使用state，避免多餘的render check
    // this.uploadedFiles = [];

    // // for downloaded files that uploaded before
    // this.onFileDrop = downloadedFiles => {
    //   onFileDrop(downloadedFiles, '', this, true);
    // };

    // this.onFileDelete = (type, fileName) => {
    //   // onFileDelete是在onFileDrop裡面會被使用，
    //   // type, fileName在裡面預設會傳入

    //   // 編輯模式下remove icon才有效

    //   if(this.state.editMode !== "View") {
    //     onFileDelete(type, fileName, this, true);
    //   }else {
    //     return;
    //   }

    // };

    // // 配合api
    // this.fileFilter = orinFiles => {
    //   // 檔案預處理
    //   let name = "", dotInd = "", type = "";

    //   const downloadedFiles = orinFiles.map((item, ind) => {
    //     name = item.file_name;
    //     dotInd = name.lastIndexOf('.');
    //     type = name.slice(dotInd + 1);

    //     switch(type) {
    //       case 'jpg':
    //         item.type = 'image/jpeg';
    //         break;
    //       case 'png':
    //         item.type = 'image/png';
    //         break;
    //       case 'svg':
    //         item.type = 'image/svg+xml';
    //         break;
    //       case 'pdf':
    //         item.type = 'application/pdf';
    //         break;
    //       case 'mp4':
    //         item.type = 'video/mp4';
    //         break;
    //       default:
    //     }

    //     return item;

    //   });

    //   return downloadedFiles;
    // };

    // this.fileWorker = (isUpload, fileId) => {
    //   let fileData = new FormData(),
    //       requreField = 'id',
    //       apiType = 'M',
    //       apiKeyWord = 'Delete',
    //       len = this.state.deletedDownloadedFiles.length;

    //   if(isUpload) {
    //     requreField = '$_FILES';
    //     apiType = 'W';
    //     apiKeyWord = 'Upload';
    //     len = this.uploadedFiles.length;
    //     fileData.append('file_id', fileId);
    //   }

    //   // api只支援一次傳一個檔，要用迴圈處理
    //   if(len > 0) {
    //     this.filesWip += len;
    //     if(!this.state.fileWorkInProgress) this.setState({fileWorkInProgress: true});

    //     fileData.append('type', 'Product');

    //     // do not make functions in a loop;
    //     let printRes = res => {
    //       this.filesWip -= 1;
    //       if(this.filesWip < 1) {
    //         this.setState({fileWorkInProgress: false});
    //         // this.props.closeModal();
    //       }
    //     };

    //     for(let i = 0; i < len; i++) {
    //       let value = "";
    //       if(isUpload) {
    //         value = this.uploadedFiles[i];
    //       }else {
    //         let fileName = this.state.deletedDownloadedFiles[i].file_name,
    //             backslashInd = fileName.lastIndexOf('/'),
    //             dotInd = fileName.lastIndexOf('.'),
    //             fileId = fileName.slice(backslashInd + 1, dotInd);

    //             value = fileId;
    //       }

    //       fileData.append(requreField, value);
    //       custJqAjax({
    //         type: 'POST',
    //         url: `/api/${apiType}_SaleSky_File${apiKeyWord}_Post.php`,
    //         data: fileData,
    //         processData: false,
    //         contentType: false,
    //         complete: printRes
    //       });
    //     }
    //   }
    // };

    // // 控制檔案上傳進度用
    // this.filesWip = 0; 

    // ======================



    // funcs
    this.funcs = {
      optsSortGen: len => {
        len++;
        let arr = [];
        for (let i = 1; i < len; i++) {
          arr.push({ value: i, label: i });
        }

        return arr;
      },
      // filePreProcessor: () => {
      //   // for downloaded files that uploaded before ====
      //   // 不可直接傳入step原因為，step可能在initialFormData中的setState之後變更
      //   // 所以這裡重抓
      //   const activeStepSort = this.props.activeStepSort.toString(),
      //         step = _find(this.props.arrStepsObj, {sort: activeStepSort}),
      //         orinFiles = [{file_name: step.file_path, thumbnail: step.thumnail}];

      //   let downloadedFiles = this.fileFilter(orinFiles);


      //   this.onFileDrop(downloadedFiles);
      //   // =======
      // },
      initialFormData: () => {
        // 產生排序選項
        const activeStepSort = this.props.activeStepSort.toString(),
          step = _find(this.props.arrStepsObj, { sort: activeStepSort });

        let sort, optsSort;
        switch (this.props.stepModMode) {
          case 'create':
            sort = this.props.stepNum + 1;
            optsSort = this.funcs.optsSortGen(sort);
            break;
          case 'edit':
            sort = activeStepSort * 1;
            optsSort = this.funcs.optsSortGen(this.props.stepNum);
            break;
          default:
        }

        // clear old file data
        // this.uploadedFiles = [];

        this.setState({
          sort,
          optsSort,
          spec_id: step ? step.spec_id : '',
          descriptions_tw: step ? step.spec_name_tw : '',
          descriptions_en: step ? step.spec_name_en : '',
          descriptions_cn: step ? step.spec_name_cn : '',
          descriptions_ja: step ? step.spec_name_ja : '',
          unit_name_tw: step ? step.unit_name_tw : '',
          unit_name_en: step ? step.unit_name_en : '',
          unit_name_cn: step ? step.unit_name_cn : '',
          unit_name_ja: step ? step.unit_name_ja : '',
          unit_value_tw: step ? step.unit_value_tw : '',
          unit_value_en: step ? step.unit_value_en : '',
          unit_value_cn: step ? step.unit_value_cn : '',
          unit_value_ja: step ? step.unit_value_ja : '',
          // clear old file data
          // downloadedFiles: [],
          // downloadedImgs: [],
          // downloadedPDFs: [],
          // downloadedVideos: [],
          // previewsImg: [],
          // previewsPDF: [],
          // previewsVideo: [],
          // deletedDownloadedFiles: [],
          // clearUploadedFileLocal: true
        });
      }
    };


    this.state = {
      // file crud 相關 ====================
      // downloadedFiles: [],
      // downloadedImgs: [],
      // downloadedPDFs: [],
      // downloadedVideos: [],
      // previewsImg: [],
      // previewsPDF: [],
      // previewsVideo: [],
      // deletedDownloadedFiles: [],
      // fileWorkInProgress: false, // 控制檔案上傳進度用
      // clearUploadedFileLocal: false, // 用以一次清空本地端上傳檔案
      // ====================
      // form
      sort: 0,
      optsSort: [],
      descriptions_tw: '',
      descriptions_en: '',
      descriptions_cn: '',
      descriptions_ja: '',
      unit_name_tw: '',
      unit_name_en: '',
      unit_name_cn: '',
      unit_name_ja: '',
      unit_value_tw: '',
      unit_value_en: '',
      unit_value_cn: '',
      unit_value_ja: '',
      // common
      btnSaveDisable: true,
      btnDeleteDisable: true,
      onEdit: false,
      onCopy: false,
      editMode: "View",
      editPermission: true
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.descriptions_tw === '' || this.state.descriptions_en === '' || this.state.descriptions_cn === '' /*||
       this.state.unit_name_tw === '' || this.state.unit_name_en === '' || this.state.unit_name_cn === '' ||
       this.state.unit_value_tw === '' || this.state.unit_value_en === '' || this.state.unit_value_cn === ''*/) {

      if (!this.state.btnSaveDisable) this.setState({ btnSaveDisable: true });
    } else if (this.state.btnSaveDisable) this.setState({ btnSaveDisable: false });

    if (
      (this.props.activeStepSort.toString() !== prevProps.activeStepSort.toString()) ||
      (this.props.arrStepsObj !== prevProps.arrStepsObj)
    ) {
      this.funcs.initialFormData();
    }

    if (this.props.activeSolutionId !== prevProps.activeSolutionId) {
      this.props.parentStateHandler({ states: ['stepModMode', 'activeStepSort'], newValues: ['', 0] });
      this.setState({ editMode: 'View' });
    }

    if (this.props.stepModMode === 'create' && prevProps.stepModMode !== 'create') {
      document.getElementById('descriptions_tw').focus();
    }
  }

  render() {

    let saveBtn = "",
      deleteBtn = "",
      editable = 0,
      modeBtns = "",
      saveBtnText = /*this.state.fileWorkInProgress ? '檔案更新中...' : */'儲存';

    if (this.state.editMode !== "View" || !this.props.activeStepSort || this.props.stepModMode === 'create') {
      saveBtn = (
        <Button className='btn-next-to-title' disabled={this.state.btnSaveDisable}
          onClick={() => { this.handlers.onSaveClick(this.props.stepModMode === 'edit' ? 1 : 0) }}>
          {saveBtnText}
        </Button>
      );
      editable = 1;
    } else {
      const permission = this.state.editPermission;
      let tipText = "";

      // if(!permission) {
      //   if(this.props.userId !== this.state.calendarOwnerId) tipText = "Only the creater is allowed to edit.";
      // else tipText = "You are allowed to edit logs which are created today";
      // }

      modeBtns = (
        <span>
          {/*<Button 
            onClick={this.handlers.onCopyClick}
            className='btn-next-to-title'>
            複製
          </Button>*/}
          <Button
            disabled={!permission}
            onClick={this.handlers.onEditClick}
            className='btn-next-to-title'>
            編輯
            {permission ? "" : <Tooltip tipText={tipText} placement="left" />}
          </Button>
        </span>
      );

    }

    deleteBtn = (this.state.onEdit && this.props.stepModMode === 'edit' && this.state.editMode === 'Edit') ?
      <DeleteBtnWithConfirm
        className='btn-next-to-title'
        onClick={this.handlers.onDeleteClick}
        title="Are you sure?" />
      : "";

    // const {previewsImg, previewsPDF, previewsVideo} = this.state,
    // downloadedFilesPreview = {previewsImg, previewsPDF, previewsVideo};

    // key part area

    return (
      <Col sm={9}>
        <Row>
          <Col sm={12}>
            <div style={{ fontWeight: "bold", position: 'relative' }}>
              項目內容維護
              <div className='div-modify-btns-container'>
                {saveBtn}
                {modeBtns}
                {deleteBtn}
              </div>
            </div>
          </Col>
        </Row>
        <Well style={{ minHeight: 800, marginBottom: 15 }}>
          {
            this.props.stepModMode ?
              <div>
                <Row>
                  {/*
                  <Col sm={12} style={{marginBottom: 20}}>
                    <FileDropAreaCt
                      singleFileLimit={true}
                      multiple={false}
                      disabled={!editable}
                      uploadedFiles={this.uploadedFiles}
                      downloadedFilesPreview={downloadedFilesPreview}
                      defaultText="點擊以上傳檔案"
                      parentStateHandler={this.parentStateHandler}
                      clearUploadedFileLocal={this.state.clearUploadedFileLocal} />
                  </Col>
                */}

                  <Col sm={12}>
                    <div style={{ fontWeight: "bold" }}><RequiredMark />規格名稱</div>
                  </Col>

                  <Col sm={12}>
                    <Well>
                      <Row>

                        <Col sm={6}>
                          <FormGroup controlId="descriptions_tw" validationState={this.state.descriptions_tw ? null : 'error'}>
                            <ControlLabel>繁體中文</ControlLabel>
                            <FormControl onFocus={this.handlers.onInputFocus} disabled={!editable} value={this.state.descriptions_tw} onChange={this.handlers.textAreaOnChange} />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup controlId="descriptions_en" validationState={this.state.descriptions_en ? null : 'error'}>
                            <ControlLabel>英文</ControlLabel>
                            <FormControl onFocus={this.handlers.onInputFocus} disabled={!editable} value={this.state.descriptions_en} onChange={this.handlers.textAreaOnChange} />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup controlId="descriptions_cn" validationState={this.state.descriptions_cn ? null : 'error'}>
                            <ControlLabel>簡體中文</ControlLabel>
                            <FormControl onFocus={this.handlers.onInputFocus} disabled={!editable} value={this.state.descriptions_cn} onChange={this.handlers.textAreaOnChange} />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup controlId="descriptions_ja">
                            <ControlLabel>日文</ControlLabel>
                            <FormControl onFocus={this.handlers.onInputFocus} disabled={!editable} value={this.state.descriptions_ja} onChange={this.handlers.textAreaOnChange} />
                          </FormGroup>
                        </Col>

                      </Row>

                    </Well>
                  </Col>

                  <Col sm={12}>
                    <div style={{ fontWeight: "bold" }}>{/*<RequiredMark />*/}單位名稱</div>
                  </Col>

                  <Col sm={12}>
                    <Well>
                      <Row>

                        <Col sm={6}>
                          <FormGroup controlId="unit_name_tw" /*validationState={this.state.unit_name_tw ? null : 'error'}*/>
                            <ControlLabel>繁體中文</ControlLabel>
                            <FormControl onFocus={this.handlers.onInputFocus} disabled={!editable} value={this.state.unit_name_tw} onChange={this.handlers.textAreaOnChange} />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup controlId="unit_name_en" /*validationState={this.state.unit_name_en ? null : 'error'}*/>
                            <ControlLabel>英文</ControlLabel>
                            <FormControl onFocus={this.handlers.onInputFocus} disabled={!editable} value={this.state.unit_name_en} onChange={this.handlers.textAreaOnChange} />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup controlId="unit_name_cn" /*validationState={this.state.unit_name_cn ? null : 'error'}*/>
                            <ControlLabel>簡體中文</ControlLabel>
                            <FormControl onFocus={this.handlers.onInputFocus} disabled={!editable} value={this.state.unit_name_cn} onChange={this.handlers.textAreaOnChange} />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup controlId="unit_name_ja">
                            <ControlLabel>日文</ControlLabel>
                            <FormControl onFocus={this.handlers.onInputFocus} disabled={!editable} value={this.state.unit_name_ja} onChange={this.handlers.textAreaOnChange} />
                          </FormGroup>
                        </Col>

                      </Row>

                    </Well>
                  </Col>

                  <Col sm={12}>
                    <div style={{ fontWeight: "bold" }}>{/*<RequiredMark />*/}單位數值</div>
                  </Col>

                  <Col sm={12}>
                    <Well>
                      <Row>

                        <Col sm={6}>
                          <FormGroup controlId="unit_value_tw" /*validationState={this.state.unit_value_tw ? null : 'error'}*/>
                            <ControlLabel>繁體中文</ControlLabel>
                            <FormControl onFocus={this.handlers.onInputFocus} disabled={!editable} value={this.state.unit_value_tw} onChange={this.handlers.textAreaOnChange} />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup controlId="unit_value_en" /*validationState={this.state.unit_value_en ? null : 'error'}*/>
                            <ControlLabel>英文</ControlLabel>
                            <FormControl onFocus={this.handlers.onInputFocus} disabled={!editable} value={this.state.unit_value_en} onChange={this.handlers.textAreaOnChange} />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup controlId="unit_value_cn" /*validationState={this.state.unit_value_cn ? null : 'error'}*/>
                            <ControlLabel>簡體中文</ControlLabel>
                            <FormControl onFocus={this.handlers.onInputFocus} disabled={!editable} value={this.state.unit_value_cn} onChange={this.handlers.textAreaOnChange} />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup controlId="unit_value_ja">
                            <ControlLabel>日文</ControlLabel>
                            <FormControl onFocus={this.handlers.onInputFocus} disabled={!editable} value={this.state.unit_value_ja} onChange={this.handlers.textAreaOnChange} />
                          </FormGroup>
                        </Col>

                      </Row>

                    </Well>
                  </Col>

                </Row>

                <Row>

                  <DropDownMenu
                    sm={12}
                    disabled={!editable}
                    required={false}
                    label="排序位置"
                    value={this.state.sort}
                    stateName="sort"
                    onChange={this.handlers.onChange}
                    options={this.state.optsSort} />

                </Row>
              </div>
              : ""
          }


        </Well>
      </Col>
    );
  }
}


// WEBPACK FOOTER //
// ./src/salesky/routes/product/SpecDetailCt.jsx